/* eslint-disable no-empty */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

// Get All Customers (GET)
export const getAllCustomers = createAsyncThunk('get All Customers', async () => {
  let response = [null, null];
  try {
    const res = await $axios.get('/users/customers');
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

// Single User information (GET)
export const getSingleUser = createAsyncThunk('get Single user', async (id) => {
  let response = [null, null];
  try {
    const res = await $axios.get(`/users/me/${id}`);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

// Update Single User (PATCH)
export const updateSingleOrder = createAsyncThunk('update Single order', async ({ userId, obj }) => {
  let response = [null, null];
  try {
    const res = await $axios.patch(`/users/${userId}`, obj);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

// Slice
const customerSlice = createSlice({
  name: 'customerSlice',
  initialState: {
    allCustomers: [],
    singleOrder: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Fetch Data
    builder
      .addCase(getAllCustomers.pending, (state) => {
        state.allCustomers = [];
      })
      .addCase(getAllCustomers.fulfilled, (state, action) => {
        if (action.payload) {
          const [resp] = action.payload;
          if (resp) {
            state.allCustomers = resp;
          } else {
            state.allCustomers = [];
          }
        }
      });
  },
});

export default customerSlice.reducer;
